'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _staticResourceConstants = require('./staticResourceConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Lib
var initialState = Immutable.Map();

// Constants


var fetchResource = function fetchResource(state, action) {
    var resourceState = Immutable.fromJS({
        fetching: true,
        fetched: false,
        data: null
    });
    return state.set(action.resourceName, resourceState);
};

var resourceFetchError = function resourceFetchError(state, action) {
    var resourceState = Immutable.fromJS({
        fetching: false,
        fetched: false,
        error: action.error
    });
    return state.set(action.resourceName, resourceState);
};

var resourceFetchSuccess = function resourceFetchSuccess(state, action) {
    var resourceState = Immutable.fromJS({
        fetching: false,
        fetched: true,
        data: action.data,
        error: null
    });
    return state.set(action.resourceName, resourceState);
};

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH:
            return fetchResource(state, action);
        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_ERROR:
            return resourceFetchError(state, action);
        case _staticResourceConstants.RESOURCE_ACTION_TYPES.RESOURCE_FETCH_SUCCESS:
            return resourceFetchSuccess(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/static/staticResourcesReducer.js
// module id = 1934
// module chunks = 0